import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  ModalListPanel,
} from 'ecs-react-components/dist/index.es';

import { messages } from './CcdaOptionsForm.i18n';

function RecentVisits({
  recentVisits,
  recentVisitIndexField,
  change,
  initRecentVisitIndexInvalid,
}) {
  if (!(recentVisits && recentVisits.length)) {
    return (<div className="marginlr20">
      <FormattedMessage {...messages.page.form.label.noVisits} />
            </div>);
  }

  const renderedItems = recentVisits.map((item, idx) => ({
    // eslint-disable-next-line react/no-unstable-nested-components
    heading: () => <span>
              <div className="message-date-box">
                <span className="message-date">{ item.encounterDate.datePart }
                </span>
              </div>
              <span className="primary-text">{item.visitType}</span>
                   </span>,
    // eslint-disable-next-line react/no-unstable-nested-components
    subText: () => <span className="secondary-text bold">
                {item.provider}
                   </span>,
    itemId: idx,
  }));

  const handleListItemClick = (index) => {
    if (index < 0) {
      return;
    }

    initRecentVisitIndexInvalid();

    change('recentVisitIndexField', index);
    change('radioValueField', 'visits');
  };

  return (
        <ModalListPanel
          items={renderedItems}
          handleListItemClick={handleListItemClick}
          qaTag="recentVisitsContainer"
          selectedIndex={recentVisitIndexField.value}
        />
  );
}

RecentVisits.propTypes = {
  recentVisits: PropTypes.array,
  recentVisitIndexField: PropTypes.object,
  change: PropTypes.func,
  initRecentVisitIndexInvalid: PropTypes.func,
}

export default RecentVisits;